// LICENSE : MIT
"use strict";

export const syntaxMap = {
    "document": "Document",
    "paragraph": "Paragraph",
    "block_quote": "BlockQuote",
    "list_item": "ListItem",
    "bullet_list": "List",
    "title": "Header",
    "literal_block": "CodeBlock",
    "reference": "Link",
    "meta": "Html",
    "text": "Str",
    "emphasis": "Emphasis",
    "strong": "Strong",
    "image": "Image",
    "inline": "Code"
};

export const reSTAttributeKeyMap = {
    "tagname": "type",
    "rawsource": "raw",
    "text": "value"
};
